/* tslint:disable */
/* eslint-disable */
/**
 * topi Seller API
 * # Localization  Strings returned can be localized when the _Accept-Language_ header is provided in the request. It should follow the [RFC-2616 convention](http://www.ietf.org/rfc/rfc2616.txt).
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const MoneyAmountWithRequiredTaxCurrencyEnum = {
    Eur: 'EUR'
};
/**
 * Check if a given object implements the MoneyAmountWithRequiredTax interface.
 */
export function instanceOfMoneyAmountWithRequiredTax(value) {
    let isInstance = true;
    isInstance = isInstance && "currency" in value;
    isInstance = isInstance && "gross" in value;
    isInstance = isInstance && "net" in value;
    isInstance = isInstance && "taxRate" in value;
    return isInstance;
}
export function MoneyAmountWithRequiredTaxFromJSON(json) {
    return MoneyAmountWithRequiredTaxFromJSONTyped(json, false);
}
export function MoneyAmountWithRequiredTaxFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'currency': json['currency'],
        'gross': json['gross'],
        'net': json['net'],
        'taxRate': json['tax_rate'],
    };
}
export function MoneyAmountWithRequiredTaxToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'currency': value.currency,
        'gross': value.gross,
        'net': value.net,
        'tax_rate': value.taxRate,
    };
}
